import { createRoute } from '@tanstack/react-router';
import { PartnersPage } from '@/features/growth/Partners';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/growth/partners',
  component: PartnersPage,
});
